import first from 'lodash/first';
import result from 'lodash/result';
import delay from 'lodash/delay';

const CLICK_DELAY = 300;

const AUTOCLOSED_MIXIN = _createOpenerMixin(true);

export default AUTOCLOSED_MIXIN;
export const OPENER_MIXIN = _createOpenerMixin(false);

function _createOpenerMixin(autoclose) {
   return {
      data() {
         return {
            isOpen: false
         };
      },
      methods: {
         toggle() {
            if (this.isOpen) {
               this.deactivate();
            } else {
               this.activate();
            }
         },
         activate() {
            this.$emit('activating');
            this._openByToggle = true;
            this.isOpen = true;
            this.$el.focus();
            clearTimeout(this._timerId);
            this._timerId = 0;
            this.$nextTick(() => this.$emit('expanded'));
         },
         deactivate() {
            this.$emit('deactivating');
            this.isOpen = false;
            if (this.$refs.list) {
               this.$refs.list.scrollTop = 0;
               this.$refs.list.scrollLeft = 0;
            }
            if (this.$el.contains(document.activeElement)) {
               this.$el.blur();
               const el = first((first(document.forms) || {}).elements);
               result(el, 'focus');
            }
            this.$nextTick(() => this.$emit('collapsed'));
         },
         deactivateWithDelay() {
            this._timerId = delay(this.deactivate, CLICK_DELAY);
         },
         _openerBackdropListener(ev) {
            let el = ev.target;
            const alive = document.body.contains(el);
            if (alive && this.isOpen && !this._openByToggle) {
               while(el) {
                  if (el === this.$el) {
                     if (autoclose) {
                        this.deactivateWithDelay();
                     }
                     return true;
                  }
                  el = el.parentNode;
               }
               this.deactivate();
               ev.stopPropagation();
               ev.preventDefault();
               return false;
            }
            this._openByToggle = false;
            return true;
         }
      },
      mounted() {
         // window.addEventListener('touchstart', this._openerBackdropListener, false);
         window.addEventListener('click', this._openerBackdropListener, false);
      },
      beforeDestroy() {
         // window.removeEventListener('touchstart', this._openerBackdropListener, false);
         window.removeEventListener('click', this._openerBackdropListener, false);
      }
   };
}
